const state = {
    company: null,
    companyEdit: null,
    companyDelete: null
}
export default state